// Check if the DOM has fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Get the <body> element
  const body = document.querySelector('body');

  // Add the class 'header-transparent' to the <body> element
  body.classList.add('header-transparent');

  // ESLint comment: The above code adds the class 'header-transparent' to the <body> element,
  // ensuring that the header is transparent as intended.
});
